import { render } from "./selectReceptorFactura.vue?vue&type=template&id=ec4fba0c"
import script from "./selectReceptorFactura.vue?vue&type=script&lang=ts"
export * from "./selectReceptorFactura.vue?vue&type=script&lang=ts"
script.render = render

export default script